import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, X } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSession } from "@/context/SessionContext";
import { useT } from "@/lib/i18n";
import { getPosition, locationGranted, nearestSite } from "@/lib/geo";
import { tankPatch } from "@/components/drop/SiteSwitcher";

const DISMISS = "fhp-near-dismissed";

export function NearbyBar() {
  const { user } = useAuth();
  const { session: s, patch } = useSession();
  const t = useT();
  const nav = useNavigate();
  const [near, setNear] = useState(null);

  useEffect(() => {
    if (!user) return;
    let live = true;
    (async () => {
      const sites = await api.getSites().catch(() => []);
      if (!sites.some((x) => x.lat != null)) return;
      if ((await locationGranted()) === false) return;
      const pos = await getPosition();
      if (live && pos) setNear(nearestSite(sites, pos));
    })();
    return () => { live = false; };
  }, [user]);

  let dismissed = null;
  try { dismissed = sessionStorage.getItem(DISMISS); } catch { /* private mode */ }
  if (!near || near.site.id === s.activeSiteId || dismissed === near.site.id) return null;

  const open = () => { patch(tankPatch(near.site, 0)); setNear(null); nav("/drop"); };
  const hide = () => { try { sessionStorage.setItem(DISMISS, near.site.id); } catch { /* private mode */ } setNear(null); };
  return (
    <div className="near-bar" data-testid="nearby-bar">
      <MapPin size={18} />
      <div className="near-text">{t("You're at {s}", { s: near.site.name })}<span className="card-sub">{t("{n} tanks saved", { n: near.site.tanks.length })}</span></div>
      <button type="button" className="primary-btn near-open" data-testid="nearby-open" onClick={open}>{t("Open")}</button>
      <button type="button" className="icon-btn icon-btn-sm" data-testid="nearby-dismiss" aria-label={t("Close")} onClick={hide}><X size={16} /></button>
    </div>
  );
}
